import { createFileRoute } from "@tanstack/react-router";
import { buildSeo, humanizeSlug } from "@/lib/seo";
import { GamePageView } from "@/components/GamePageView";
import { gameMetaDescription, gameTitle, buildGameFaqs, type GameCopyInput } from "@/lib/page-copy";
import { gameOgImage } from "@/lib/og-images";
import { relatedGamesForGame, relatedStatesForGame } from "@/lib/related-links";
import {
  articleSchema,
  breadcrumbSchema,
  faqPageSchema,
  gameSchema,
  itemListSchema,
} from "@/lib/jsonld";

export const Route = createFileRoute("/games/$gameSlug/")({
  head: ({ params }) => {
    const name = humanizeSlug(params.gameSlug);
    const path = `/games/${params.gameSlug}`;
    const copy: GameCopyInput = { name, slug: params.gameSlug };
    const description = gameMetaDescription(copy);
    const image = gameOgImage(params.gameSlug);
    const relatedGames = relatedGamesForGame(params.gameSlug);
    const relatedStateLinks = relatedStatesForGame(params.gameSlug, true);
    return buildSeo({
      title: gameTitle(copy),
      description,
      path,
      image,
      jsonLd: [
        faqPageSchema(buildGameFaqs(copy)),
        gameSchema({
          name: `${name} Lottery`,
          path,
          description: `${name} draw game: winning numbers, jackpot estimates, draw schedule and full results history.`,
        }),
        articleSchema({
          headline: `${name} Results & Winning Numbers`,
          description,
          path,
          image,
          section: "Lottery results",
          keywords: [`${name} results`, `${name} winning numbers`, `${name} jackpot`],
        }),
        breadcrumbSchema([
          { name: "Home", item: "/" },
          { name, item: path },
        ]),
        itemListSchema(`Games related to ${name}`, relatedGames),
        itemListSchema(`States where ${name} players check results`, relatedStateLinks),
      ],
    });
  },
  component: GameRoute,
});

function GameRoute() {
  const { gameSlug } = Route.useParams();
  return <GamePageView gameSlug={gameSlug} />;
}